import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter
    ? `, filter: ${convertFilterRequestUrl(filter, ['type', 'status'])}`
    : '';
  const getJobDetailReport = `getJobDetailReport(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${getJobDetailReport} {
        jobScheduleDate
        accountId
        company
        firstName
        lastName
        errorCode
        jobId
        jobType
        jobStatus
      }
    }
  `;
};
